import { Component } from '@angular/core';

@Component({
  selector: 'app-info-page',
  templateUrl: './info-page.component.html'
})
export class InfoPageComponent  {

}
